<template>
  <div class="all-consent-bar" :class="{ reverse: settings.reverseAllConsentButtonsOrder == 1 }">
    <button
      v-if="!settings.hideAcceptAll"
      type="button"
      class="btn accept-all"
      @click="$emit('click', true)"
      :style="acceptAllStyle"
      :aria-label="$t('acceptAllAria')"
      v-html="settings.acceptAllText || $t('acceptAll')"
    ></button>
    <button
      v-if="!settings.hideRefuseAll"
      type="button"
      class="btn refuse-all"
      @click="$emit('click', false)"
      :style="refuseAllStyle"
      :aria-label="$t('refuseAllAria')"
      v-html="settings.refuseAllText || $t('refuseAll')"
    ></button>
  </div>
</template>
<script>
import { i18nMixin } from 'shared/i18n/i18n-mixin';

export default {
  mixins: [i18nMixin],
  props: {
    settings: {
      type: Object,
      required: true,
    },
    useStyleAttr: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    acceptAllStyle() {
      if (this.useStyleAttr) {
        return { background: this.settings.acceptAllBgColor, color: this.settings.acceptAllTextColor };
      } else {
        return null;
      }
    },
    refuseAllStyle() {
      if (this.useStyleAttr) {
        return { background: this.settings.refuseAllBgColor, color: this.settings.refuseAllTextColor };
      } else {
        return null;
      }
    },
  },
};
</script>
<style lang="less">
.all-consent-bar {
  display: flex;
  flex-direction: row;
  &.reverse {
    flex-direction: row-reverse;
  }
  button {
    margin-right: 3px;
  }
}
</style>
